define('modules/newsletter-story/newsletter-story',[
        'jquery',
        'underscore',
        'baseview',
        'utils',
        'state',
        'user-manager',
        'pubsub'
    ],
    function(
        $,
        _,
        BaseView,
        Utils,
        StateManager,
        UserManager,
        PubSub
    ) {
        'use strict';
        var NewsletterStory = BaseView.extend({

            validEmail: function(email) {
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            events: {
                'submit': 'onFormSubmit',
                'blur .nssm-email-input': 'validateEmail'
            },

            /**
             * Initialize view.
             */
            initialize: function(options) {
                this.$elm = this.$('.nssm-wrapper');
                var newsletterCount = parseInt(Utils.getNested(this.$elm, 'context', 'dataset', 'newsletterCount'), 10);
                StateManager.fetchData(null, {
                    url: Utils.getNested(window.site_vars, 'gup', 'gupas_path') + '/' + Utils.getNested(window.site_vars, 'site_code') + '-GUP/user/newsletters/',
                    withCredentials: true
                }).done(_.bind(function(response) {
                    var subscriptions = [];
                    var newsletter = {};
                    var el;
                    if (Utils.getNested(response, 'meta', 'status') === 200) {
                        subscriptions = _.filter(Utils.getNested(response, 'response', 'newsletters'), function (n) {
                            return n.isSubscribed;
                        });
                    }
                    for (var i=1; i <= newsletterCount; i++) {
                        el = $(document.getElementById('story-newsletter-' + i.toString()));
                        newsletter = this.searchForListCode(subscriptions, el.data('newsletter-id'));
                        if(_.isEmpty(newsletter)) {
                            el.removeAttr('hidden');
                            break;
                        }
                    }
                    // caching selectors
                    if (el) {
                        this.$nlForm = el.find('.nssm-form');
                        this.$nlFormAction = this.$nlForm.attr('action');
                        this.$emailField = el.find('.nssm-email-input');
                        this.$submit = el.find('.nssm-submit');
                        this.$submitVal = this.$submit.val();
                        this.$nlEmailFailure = el.find('.nssm-email-invalid-msg');
                        this.layoutType = Utils.getNested(options, 'layoutType');
                        if(this.layoutType && this.layoutType.indexOf('MESSAGING') > -1) {
                            this.position = 'inline';
                        } else {
                            this.position = 'sidebar';
                        }
                        this.userAccount = UserManager.getAccount('firefly');
                        if (this.userAccount) {
                            this.userAccount.getUserInfo().done(_.bind(function(userInfo) {
                                if (userInfo.email) {
                                    this.$currentUserEmail = userInfo.email;
                                    this.$emailField.val(this.$currentUserEmail);
                                }
                            }, this));
                        }
                    }
                }, this));
            },

            onFormSubmit: function(e) {
                e.preventDefault();
                if (this.validateEmail()) {
                    this.$submit.addClass("disabled");
                    this.$submit.val("");
                    var newsletter_choices = [];
                    newsletter_choices.push({
                        listCode: this.$nlForm.data("newsletter-id"),
                        isSubscribed: true
                    });

                    var request_json = {
                            request: {
                                email: this.$emailField.val().toString(),
                                newsletters: newsletter_choices
                            }
                        };

                    StateManager.fetchData(this.$nlFormAction, {
                        type: "POST",
                        withCredentials: true,
                        data: JSON.stringify(request_json)
                    }).done(_.bind(function(response) {
                        if (response.meta.status == 200) {
                            this.$nlForm.hide();
                            $('.nssm-success-msg').show();
                            this.trackLabel = window.utag_data.ssts + "|" + this.position + "-newsletter-signup|successsignup";
                        } else {
                            this.$submit.removeClass("disabled");
                            this.$submit.val(this.$submitVal);
                            $('.nssm-default-title').hide();
                            $('.nssm-failure-title').show();
                            $('.nssm-default-description').hide();
                            $('.nssm-failure-description').show();
                            this.trackLabel = window.utag_data.ssts + "|" + this.position + "-newsletter-signup|errorunabletoprocess";
                        }

                       PubSub.trigger('newslettersignupcta', this.trackLabel);
                    }, this)).fail(_.bind(function() {
                        this.$submit.removeClass("disabled");
                        this.$submit.val(this.$submitVal);
                        $('.nssm-default-title').hide();
                        $('.nssm-failure-title').show();
                        $('.nssm-default-description').hide();
                        $('.nssm-failure-description').show();
                        this.trackLabel = window.utag_data.ssts + "|" + this.position + "-newsletter-signup|errorunabletoprocess";

                        PubSub.trigger('newslettersignupcta', this.trackLabel);
                    }, this));
                } else {
                    PubSub.trigger('newslettersignupcta', window.utag_data.ssts + "|" + this.position + "-newsletter-signup|errorinvalidemail");
                }
            },

            validateEmail: function() {
                if (!this.$emailField.val() || !this.validEmail(this.$emailField.val())) {
                    this.$emailField.addClass("email-invalid");
                    this.$nlEmailFailure.show();
                    return false;
                } else {
                    this.$emailField.removeClass("email-invalid");
                    this.$nlEmailFailure.hide();
                    return true;
                }
            },

            searchForListCode: function (s, i) {
                return _.find(s,function (l) {
                                return l.listCode === i;
                });
            }
        });

        /**
         * Return view class.
         */
        return NewsletterStory;
    });

